var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup127(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.95154 12.7C7.95154 10.1545 7.95154 8.88171 8.81237 8.09086C9.67324 7.30005 11.0587 7.30005 13.8297 7.30005H14.8094C17.5803 7.30005 18.9658 7.30005 19.8266 8.09086C20.6875 8.88171 20.6875 10.1545 20.6875 12.7V13.6C20.6875 16.1456 20.6875 17.4184 19.8266 18.2092C18.9658 19 17.5803 19 14.8094 19H13.8297C11.0587 19 9.67324 19 8.81237 18.2092C7.95154 17.4184 7.95154 16.1456 7.95154 13.6V12.7Z",
    stroke: "#686868",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.789 7.3C15.7866 4.63862 15.7428 3.26009 14.8995 2.31619C14.7367 2.1339 14.5548 1.96676 14.3564 1.81716C13.2724 1 11.6621 1 8.44141 1C5.2207 1 3.61035 1 2.52647 1.81716C2.32805 1.96675 2.14611 2.1339 1.98327 2.31619C1.09375 3.3119 1.09375 4.79127 1.09375 7.75C1.09375 10.7087 1.09375 12.1881 1.98327 13.1838C2.1461 13.3661 2.32805 13.5332 2.52647 13.6828C3.55395 14.4575 5.05454 14.4978 7.95156 14.4999",
    stroke: "#686868",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup127);
export default __webpack_public_path__ + "static/media/Group 127.1aff42e34db36904f7cc6f6622257093.svg";
export { ForwardRef as ReactComponent };